import React from 'react';
import { Row, Select } from 'antd';

import OnTraccrTextInput from '../../../common/inputs/OnTraccrTextInput';

import OptionalRow from './OptionalRow';
import MultiSignaturePreview from './MultiSignaturePreview';
import FieldTriggerCheckbox from './FieldTriggerCheckbox';
import ConditionalRenderingRow from './ConditionalRenderingRow';
import OnTraccrCheckbox from '../../../common/inputs/OnTraccrCheckbox';

const configure = ({
  setConfigProps,
  configProps = {},
  sections = [],
  isExternalForm,
  templateId,
  divisions,
  projectId,
  name,
  projectIdMap = {},
  vendors = [],
  equipment = [],
  isBoardCards,
  setFieldTriggerEditable,
  disableOptional,
  id,
  formTemplates = [],
  labels = [],
  contactAddressBooks = {},
  customers = [],
  projects = [],
  users = [],
  costcodes = [],
  phases = [],
  buckets = [],
  scheduleCategories = [],
} = {}) => {
  const {
    optional,
    hasConditionalRendering = false,
    conditionalRenderingFormula,
    isHideInPDF,
    showSignatureTime,
    collectGeolocation,
  } = configProps;

  const setTitle = (e) => {
    const {
      target:{
        value,
      } = {},
    } = e;
    setConfigProps({
      ...configProps,
      title:value,
    });
  };
  const setOptional = (checked) => {
    setConfigProps({
      ...configProps,
      optional: checked,
    });
  };

  const setLinkedField = (fieldId) => {
    setConfigProps({
      ...configProps,
      linkedField:fieldId,
    });
  }

  const setConditionalRenderingFormula = (formula) => {
    setConfigProps({
      ...configProps,
      conditionalRenderingFormula: formula,
    });
  };

  const setHasConditionalRendering = (checked) => {
    setConfigProps({
      ...configProps,
      hasConditionalRendering: checked,
    });
  };

  const setFieldTrigger = (checked) => {
    setConfigProps({
      ...configProps,
      fieldTrigger: checked,
    });
  };

  const setHideInPDF = (checked) => {
    setConfigProps({
      ...configProps,
      isHideInPDF: checked,
    });
  };

  const setShowSignatureTime = (checked) => {
    setConfigProps({
      ...configProps,
      showSignatureTime: checked,
    });
  };

  const setCollectGeolocation = (checked) => {
    setConfigProps({
      ...configProps,
      collectGeolocation: checked,
    });
  };

  const userFields = sections.reduce((acc,{ fields = [], name: sectionName }) => (
    acc.concat(
      fields.reduce((fieldAcc, field) => {
        const { selectedType, id, configProps: { dataType, title } = {} } = field;
        if (selectedType === 'dropdown' && dataType === 'Users') {
          return fieldAcc.concat([{ value: id, label: `${sectionName} - ${title}` }]);
        }
        return fieldAcc
      },[])
    )
  ),[]);

  return (
    <div>
      <Row className='form-required-field'>
        Title:
      </Row>
      <Row style={{ marginTop: 5 }}>
        <OnTraccrTextInput
          textarea placeholder='Insert title here'
          onChange={setTitle}
          value={configProps.title}
        />
      </Row>
      <OptionalRow onChange={setOptional} optional={optional} disabled={disableOptional}/>
      <ConditionalRenderingRow
        onChange={setHasConditionalRendering}
        onFormulaChange={setConditionalRenderingFormula}
        id={id}
        hasConditionalRendering={hasConditionalRendering}
        conditionalRenderingFormula={conditionalRenderingFormula}
        sections={sections}
        customers={customers}
        projects={projects}
        users={users}
        costcodes={costcodes}
        phases={phases}
        projectIdMap={projectIdMap}
        vendors={vendors}
        equipment={equipment}
        formTemplates={formTemplates}
        labels={labels}
        contactAddressBooks={contactAddressBooks}
        buckets={buckets}
        scheduleCategories={scheduleCategories}
      />
      <OnTraccrCheckbox
        style={{ marginTop: 10 }}
        label="Hide in PDF"
        value={isHideInPDF}
        onChange={setHideInPDF}
        hoverNode="Check this to hide this field in the PDF preview and export"
      />
      <OnTraccrCheckbox
        style={{ marginTop: 10 }}
        label="Show signature time"
        value={showSignatureTime}
        onChange={setShowSignatureTime}
        hoverNode="Display the time alongside the date when a signature is captured"
      />
      <OnTraccrCheckbox
        style={{ marginTop: 10 }}
        label="Collect geolocation"
        value={collectGeolocation}
        onChange={setCollectGeolocation}
        hoverNode="Capture and display GPS coordinates when a signature is signed (mobile only)"
      />
      <Row style={{ marginTop: 15 }}>
        User Dropdown Field:
      </Row>
      <Row style={{ marginTop: 10 }} gutter={10}>
        <Select
          style={{ width: '100%', margin:'0px 10px'}}
          placeholder='Select user field'
          onSelect={setLinkedField}
          value={configProps.linkedField}
          optionFilterProp='label'
          options={userFields}
        />
      </Row>
      {!isBoardCards && !isExternalForm && (
        <FieldTriggerCheckbox
          onChange={setFieldTrigger}
          onEditableChange={setFieldTriggerEditable}
          sections={sections}
          projectId={projectId}
          templateId={templateId}
          divisions={divisions}
          configProps={configProps}
          setConfigProps={setConfigProps}
          name={name}
        />
      )}
    </div>
  )
};

export default {
  configure,
  preview: (props) => <MultiSignaturePreview {...props}/>,
  title: 'Multi Signature Field',
  description: 'Collect signatures from multiple users',
};
